// Configuration file for API keys and other environment-specific values
const config = {
  // API key for OpenAI
  OPENAI_API_KEY: process.env.REACT_APP_OPENAI_API_KEY
};

export default config;